import { GET_DEVICES } from '@/libs/onboarding/queries';
import { useLazyQuery } from '@apollo/client/react/hooks';
import { Device, DeviceMode } from '../types';
import { DocumentNode } from '@apollo/client';

interface UseDevicesOptions {
  query?: DocumentNode;
}

export const useDevices = <T = Device>(options: UseDevicesOptions = {}) => {
  const query = options.query || GET_DEVICES;

  const [refetch, { data, loading, error }] = useLazyQuery<{
    devices: T[];
  }>(query, {
    fetchPolicy: 'no-cache',
    variables: {
      filters: {
        mode: DeviceMode.ORB,
      },
    },
  });

  return {
    devices: data?.devices || [],
    loading,
    error,
    fetchDevices: refetch,
  };
};
